<vectronic-filter-header
  (titleClicked)="toggleFilter()"
  [title]="title()"
  (enabledFilterToggle)="toggleFilter()"
  [isFilterEnabled]="!isFilterHidden()"
  [disabled]="disabled()"
></vectronic-filter-header>
<div class="filter-body" [hidden]="isFilterHidden()">
  <vectronic-chips-filter
    [items]="availableFilterItems()"
    [defaultSelectedItems]="selectedFilterItems()"
    [disabled]="disabled()"
    (selectItem)="onSelectItem($event)"
    (deleteItem)="onDeleteItem($event)"
  ></vectronic-chips-filter>
</div>
